import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.spiThresholds`;
export const INIT = `${SCOPE}/INIT`;

export const FETCH_SPI_THRESHOLD = `${SCOPE}/FETCH_SPI_THRESHOLD`;
export const SET_SPI_THRESHOLD = `${SCOPE}/SET_SPI_THRESHOLD`;
export const SAVE_USER_KPI_PREFERENCE = `${SCOPE}/SAVE_USER_KPI_PREFERENCE`;
export const UPDATE_CUSTOM_KPI = `${SCOPE}/UPDATE_CUSTOM_KPI`;
export const DELETE_CUSTOM_KPI = `${SCOPE}/DELETE_CUSTOM_KPI`;
export const SET_CURRENT_CONFIG = `${SCOPE}/SET_CURRENT_CONFIG`;
export const SET_EDITABLE_FLAG = `${SCOPE}/SET_EDITABLE_FLAG`;
export const SET_SELECTED_CONFIG = `${SCOPE}/SET_SELECTED_CONFIG`;
export const UPDATE_SELECTED_CONFIG = `${SCOPE}/UPDATED_SELECTED_CONFIG`;
export const SAVE_AND_APPLY = `${SCOPE}/SAVE_AND_APPLY`;
export const SELECT_CREATE_NEW = `${SCOPE}/SELECT_CREATE_NEW`;
export const SET_ERROR = `${SCOPE}/SET_ERROR`;
export const SET_FETCHING = `${SCOPE}/SET_FETCHING`;
export const SET_INITIALIZING = `${SCOPE}/SET_INITIALIZING`;
